import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import JournalArticleCard from '../components/JournalArticleCard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Journal() {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/journal`);
      setArticles(response.data);
    } catch (error) {
      console.error('Error fetching articles:', error);
    }
  };

  return (
    <div className="min-h-screen section-padding bg-soft-ivory" data-testid="journal-page">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16 space-y-4"
        >
          <h1 className="heading-1">Journal</h1>
          <p className="body-text text-dark-cedar/70">Insights on wellness, tea culture, and ritual practices</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <JournalArticleCard key={article.id} article={article} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
}